export enum DuplicateAction {
    Reject = "reject",
    Accept = "accept",
    Edit = "edit",
    Merge = "merge",
    None = "",
}
